import { render, staticRenderFns } from "./ItemList.vue?vue&type=template&id=17828250&"
import script from "./ItemList.vue?vue&type=script&lang=ts&"
export * from "./ItemList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports